export enum ClientabeType {
  CLIENT = 'App\\Models\\Client',
  HOTEL = 'App\\Models\\Hotel',
  SUPPLIER = 'App\\Models\\Supplier',
  COMPANY = 'App\\Models\\Company',
}
